import { render, staticRenderFns } from "./BPoint.vue?vue&type=template&id=2831e596&scoped=true&"
import script from "./BPoint.vue?vue&type=script&lang=ts&"
export * from "./BPoint.vue?vue&type=script&lang=ts&"
import style0 from "./BPoint.vue?vue&type=style&index=0&id=2831e596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2831e596",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VImg,VLayout})
